import { db } from "../firebase-config";
import { collection, query, doc, where, onSnapshot } from "firebase/firestore";

// Real-time listener for all employees in an organization
export const organizationEmployeesSnapshotListener = (organization, onEmployeeUpdate) => {
    const employeeQuery = query(collection(db, "organizations", organization, "employees"))
    const unsubscribe = onSnapshot(employeeQuery, (querySnapshot) => {
        const employeeItems = [];
        querySnapshot.forEach((doc) => {
          employeeItems.push({ id: doc.id, ...doc.data() });
        });
        onEmployeeUpdate(employeeItems);
    })
    return () => unsubscribe()
}

// Real-time listener for a single employee by UID
export const organizationEmployeeSnapshotListener = (organization, uid, onEmployeeUpdate) => {
    const employeeDocRef = doc(db, "organizations", organization, "employees", uid);

    const unsubscribe = onSnapshot(employeeDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            onEmployeeUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
            onEmployeeUpdate(null);
        }
    });
    return unsubscribe;
};

// Snapshot listener for employee performance reviews
export const employeePerformanceReviewsSnapshotListener = (organization, employeeId, setPerformanceReviews) => {
    const docsQuery = query(collection(db, "organizations", organization, "employees", employeeId, "performance_reviews"));
    const unsubscribe = onSnapshot(docsQuery, (querySnapshot) => {
        const docs = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setPerformanceReviews(docs);
    });
    return () => unsubscribe();
};